var _defs, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _path, _path2, _text, _text2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSimplexsolutionslogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 343.59 244.66",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:#fff;}.cls-3{fill:url(#linear-gradient-2);}.cls-4{fill:url(#linear-gradient-3);}.cls-5{stroke-miterlimit:10;stroke-width:0.21px;fill:url(#linear-gradient-4);stroke:url(#linear-gradient-5);}.cls-6{fill:url(#linear-gradient-6);}.cls-7{font-size:28.95px;fill:#1b75bb;font-family:Calibri-Bold, Calibri;}.cls-10,.cls-7{font-weight:700;}.cls-8{letter-spacing:-0.01em;}.cls-9{letter-spacing:0em;}.cls-10{font-size:47.12px;font-family:BodoniMT-Bold, Bodoni MT;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 189.98,
    y1: 276.69,
    x2: 302.35,
    y2: 276.69,
    gradientTransform: "matrix(0, 0.99, -0.98, 0, 470.29, -98.96)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#1b75bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#1b75bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#00adee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#1b75bb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1b75bb"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 190.94,
    y1: 243.57,
    x2: 295.21,
    y2: 243.57,
    gradientTransform: "matrix(0, 1, -1.04, 0, 460.93, -111.82)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f6921e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f6921e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#fff100"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#f6921e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f6921e"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 211.12,
    y1: 222.62,
    x2: 282.02,
    y2: 221.85,
    gradientTransform: "matrix(0, 1, -1.04, 0, 451.13, -129.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fbd20a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.38,
    stopColor: "#f7da22"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "#f9ec31"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#f6de2e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3e840"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 129.36,
    y1: 118.36,
    x2: 273.3,
    y2: 118.36,
    gradientTransform: "matrix(1.05, -0.19, 0.19, 1.05, -31.49, 67.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f5c035"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#f0bb39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#f1bb3e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f0bb39"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.69,
    stopColor: "#f3bd33"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#efbd38"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ba40"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 129.26,
    y1: 118.36,
    x2: 273.4,
    y2: 118.36,
    gradientTransform: "matrix(1.05, -0.19, 0.19, 1.05, -31.49, 67.43)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0bc3a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#f2be3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#f1c03b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#f1bc3d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#f3c34c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f3c03d"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 181.7,
    y1: 168.99,
    x2: 302.98,
    y2: 168.99,
    gradientTransform: "matrix(1.22, 0.05, -0.09, 1.23, -81.74, -65.07)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f19120"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#ee9521"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ee9521"
  })))), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-1",
    cx: 198.49,
    cy: 143.81,
    rx: 53.85,
    ry: 55.41,
    transform: "translate(-60.83 147.77) rotate(-55.38)"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 203.59,
    cy: 137.05,
    rx: 40.39,
    ry: 54.22,
    transform: "translate(-53.07 149.05) rotate(-55.38)"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-3",
    cx: 207.79,
    cy: 130.98,
    rx: 37.03,
    ry: 52.07,
    transform: "translate(-46.26 149.88) rotate(-55.38)"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 218.08,
    cy: 115.55,
    rx: 19.23,
    ry: 40.4,
    transform: "translate(-29.12 151.69) rotate(-55.38)"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 220.12,
    cy: 112.6,
    rx: 18.1,
    ry: 35.41,
    transform: "translate(-25.81 152.09) rotate(-55.38)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M267.58,82.08c-7.07-5.65-33.54,16-33.17,16.64S254.24,85,259.8,90c6,5.32-7,30.13-15.74,45.26-5.41,9.36-12.44,21.54-25.25,35.27-16.82,18-63.89,51.43-72.11,43.1-6.19-6.28,12.63-33.2,12.1-33.48s-27.22,36.73-19.92,44.27c7.58,7.83,51.43-16.57,82.65-50C255.33,138.12,276.35,89.1,267.58,82.08Z",
    transform: "translate(-28.2 -77.67)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M267.5,228.49c9.34-9-19.62-54.18-21.61-53.31-1.69.75,17,34.47,8.89,41.1-8.83,7.21-45.12-21.11-69-46.75-27.85-29.88-54-71.63-45.32-80.53,6.31-6.47,28.8,6.75,29.43,5.28.74-1.72-29-22.19-37.13-15.14C122.63,87.93,146.64,139,181.11,176,212.64,209.83,258.27,237.37,267.5,228.49Z",
    transform: "translate(-28.2 -77.67)"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "cls-7",
    transform: "translate(76.66 234.56)"
  }, "Simply The Be", /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 169.01,
    y: 0
  }, "s"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 180.23,
    y: 0
  }, "t"))), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "cls-10",
    transform: "translate(0 191.34)"
  }, "Simplex Solutions")));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSimplexsolutionslogo);
export default __webpack_public_path__ + "static/media/simplexsolutionslogo.d4e8afc74ebaef646a574dd006726820.svg";
export { ForwardRef as ReactComponent };